import commonActionTypes from './action-types';

export const setContext = value => ({
  type: commonActionTypes.SET_CONTEXT,
  payload: value,
});

export const fetchStaticData = value => ({
  type: commonActionTypes.FETCH_STATIC_DATA,
  payload: value,
});

export const fetchStaticDataSuccess = value => ({
  type: commonActionTypes.FETCH_STATIC_DATA_SUCCESS,
  payload: value,
});

export const fetchStaticDataFail = value => ({
  type: commonActionTypes.FETCH_STATIC_DATA_FAIL,
  payload: value,
});

export const fetchSearchProducts = payload => ({
  type: commonActionTypes.FETCH_SEARCH_PRODUCTS,
  payload,
});

export const fetchSearchProductsSuccess = payload => ({
  type: commonActionTypes.FETCH_SEARCH_PRODUCTS_SUCCESS,
  payload,
});

export const fetchSearchProductsFail = payload => ({
  type: commonActionTypes.FETCH_SEARCH_PRODUCTS_FAIL,
  payload,
});

export const resetSearchProducts = payload => ({
  type: commonActionTypes.RESET_SEARCH_PRODUCTS,
  payload,
});
